import { Ulid } from "@kase/my-marathon-communication";

export const getIdWithCompany = (
    id: string | Readonly<Ulid>,
    company: string,
) => `${company}-${id.toString()}`;

export const splitIdWithCompany = (id: string) => {
    const [company, ...rest] = id.split("-");

    return [company, rest.join("-")];
};
